export default "__VITE_ASSET__fa0849b8__"